import {PhotoGallery} from '../photo-gallery/photo-gallery';

type Options = Partial<GalleryFullOptions>;

export interface GalleryElement extends HTMLElement {
  gallery?: GalleryFullscreen;
}

export interface GalleryFullOptions {
  dataIndex: string;
  triggerEl: string;
}

export class GalleryFullscreen {
  static defaults = {
    dataIndex: 'slideIndex',
    triggerEl: '[data-galleryfull-image]',
  };
  element: GalleryElement;
  options: GalleryFullOptions;
  clickHandler: EventListener;

  constructor(element: GalleryElement, options: Options = {}) {
    if (!element || element.gallery) {
      return;
    }

    element.gallery = this;
    this.element = element;
    this.options = {
      ...GalleryFullscreen.defaults,
      ...this.element.dataset,
      ...options,
    };

    this.bind();
  }

  bind() {
    this.clickHandler = this.handleClick.bind(this);
    this.element.addEventListener('click', this.clickHandler);
  }

  handleClick(event: Event) {
    const target = event.target as HTMLElement;
    const match = target.closest(this.options.triggerEl) as HTMLElement;

    if (!match) {
      return;
    }

    event.preventDefault();
    const index = this.getIndex(match);

    if (index !== -1) {
      this.initGallery(index);
    }
  }

  getIndex(target: HTMLElement): number {
    const index = target.dataset[this.options.dataIndex];

    if (index || index === '0') {
      return parseInt(index, 10);
    }

    return -1;
  }

  initGallery(index: number) {
    return new PhotoGallery(this.element, {
      start_index: index,
    });

    // import(/* webpackChunkName: "fullscreen" */ '../photo-gallery').then(
    //   ({PhotoGallery}) => {
    //     new PhotoGallery(this.container, {
    //       start_index: index,
    //     });
    //   },
    // );
  }

  destroy() {
    this.element.removeEventListener('click', this.clickHandler);
    this.element.gallery = undefined;
  }
}
